/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = NotStarted
 *
 * 1 = Working
 *
 * 2 = Break
 *
 * 3 = DayFinished
 */
export enum WorkingHoursTrackerStatuses {
  NotStarted = 0,
  Working = 1,
  Break = 2,
  DayFinished = 3,
}
